<template>
  <header class="fixed z-50 w-full bg-white shadow-sm">
    <div class="container flex items-center justify-between h-16 px-4 mx-auto md:px-6 md:h-20">
      <!-- Logo/Brand -->
      <router-link to="/" class="flex items-center">
        <img src="https://www.ticketjobhub.com/logo.png" alt="Logo Icon" class="hidden w-8 h-8 mr-2 sm:block">
        <!-- 电脑版显示完整名称，手机版显示简称 -->
        <span class="hidden text-2xl md:text-3xl md:block font-['Pacifico'] text-red-600">Ticket Job Hub</span>
        <span class="text-2xl md:hidden font-['Pacifico'] text-red-600">Ticket Job Hub</span>
      </router-link>
      
      <!-- Mobile Menu Button -->
      <button 
        @click="isOpen = !isOpen"
        class="text-gray-600 lg:hidden hover:text-red-600"
      >
        <svg
          v-if="!isOpen"
          class="block w-6 h-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
        <svg
          v-if="isOpen"
          class="block w-6 h-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      
      <!-- Desktop Navigation -->
      <nav class="items-center hidden space-x-8 lg:flex">
        <router-link to="/" class="font-medium text-gray-900 hover:text-red-600">Home</router-link>
        <router-link to="/jobs" class="font-medium text-gray-900 hover:text-red-600">Jobs</router-link>
        <router-link to="/companies" class="font-medium text-gray-900 hover:text-red-600">Companies</router-link>
        <router-link to="/about" class="font-medium text-gray-900 hover:text-red-600">About Us</router-link>
        <router-link to="/contact" class="font-medium text-gray-900 hover:text-red-600">Contact</router-link>
      </nav>
      
      <!-- Desktop Buttons -->
      <div class="items-center hidden space-x-4 lg:flex">
        <button @click="jumpTo()"
          class="px-6 py-2 font-medium text-red-600 transition-colors duration-300 border border-red-600 rounded-md hover:bg-red-600 hover:text-white whitespace-nowrap">Sign In</button>
        <button @click="jumpTo('register')"
          class="px-6 py-2 font-medium text-white transition-colors duration-300 bg-red-600 rounded-md hover:bg-red-700 whitespace-nowrap">Register</button>
      </div>
    </div>
    
    <!-- Mobile Menu -->
    <div
      v-show="isOpen"
      class="absolute w-full bg-white shadow-lg lg:hidden"
    >
      <div class="px-4 py-3 space-y-3">
        <router-link
          to="/"
          class="block py-2 font-medium text-gray-900 hover:text-red-600"
          @click.native="isOpen = false"
        >
          Home
        </router-link>
        <router-link
          to="/jobs"
          class="block py-2 font-medium text-gray-900 hover:text-red-600"
          @click.native="isOpen = false"
        >
          Jobs
        </router-link>
        <router-link
          to="/companies"
          class="block py-2 font-medium text-gray-900 hover:text-red-600"
          @click.native="isOpen = false"
        >
          Companies
        </router-link>
        <router-link
          to="/about"
          class="block py-2 font-medium text-gray-900 hover:text-red-600"
          @click.native="isOpen = false"
        >
          About Us
        </router-link>
        <router-link
          to="/contact"
          class="block py-2 font-medium text-gray-900 hover:text-red-600"
          @click.native="isOpen = false"
        >
          Contact
        </router-link>
        
        <!-- Mobile Buttons -->
        <div class="flex flex-col pt-2 space-y-2 border-t border-gray-200">
          <button @click="jumpTo()"
            class="w-full py-2 font-medium text-center text-red-600 transition-colors duration-300 border border-red-600 rounded-md hover:bg-red-600 hover:text-white">Sign In</button>
          <button @click="jumpTo('register')"
            class="w-full py-2 font-medium text-center text-white transition-colors duration-300 bg-red-600 rounded-md hover:bg-red-700">Register</button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { jumpTo } from '@/utils/navigation';
export default {
  name: 'TheNavbar',
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    jumpTo
  }
}
</script>